import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import About from "./component/About";
import Contact from "./component/Contact";
import Home from "./component/Home";
import JavaFullStack from './component/JavaFullStack';
import MernStack from './component/Mernstack';
import Navbar from "./component/Navbar";
import Projects from "./component/Projects";
import PythonDevelopment from './component/PythonDevelopment';
import Services from "./component/Services";
import "./component/style.css";
import Training from "./component/Training";

function App() {
  return (
    <Router>
      <Navbar />
<Routes>
   <Route path="/" element={<Home/>}/>
   <Route path="/about" element={<About/>}/>
    <Route path="/service" element={<Services/>}/>
     <Route path="/training" element={<Training/>}/>
      <Route path="/project" element={<Projects/>}/>
       <Route path="/contact" element={<Contact/>}/>
        <Route path='/training/javafullstack'  element={<JavaFullStack/>}/>
        <Route path='/training/mern'   element={<MernStack/>}/>
        <Route path="/training/pythondevelopment"  element={<PythonDevelopment/>}/>
</Routes>
      
      <footer>
        <h3>NASONS'S Technologies Solutions</h3>
        <p>
          Software Development | Industrial Automation | Training
        </p>
        <p>© 2026 All Rights Reserved.</p>
      </footer>
    </Router>
  );
}

export default App;